import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export type ExclusionType = 'scheduled_delivery' | 'ordering';

export interface DateExclusionRow {
  id: number;
  seller_company_id: number;
  seller_company_name: string | null;
  exclusion_type: ExclusionType;
  exclusion_start_date: string; // YYYY-MM-DD
  exclusion_end_date: string; // YYYY-MM-DD
  created_date: string | null;
}

@Injectable({ providedIn: 'root' })
export class DateExclusionService {
  private readonly url = `${environment.api_url_v1}/services/user/date_exclusions`;

  constructor(private http: HttpClient) {}

  list(
    sellerCompanyIds: number[],
    type: ExclusionType = 'scheduled_delivery',
  ): Observable<any> {
    const params = new HttpParams()
      .set('seller_company_id', sellerCompanyIds.join(','))
      .set('exclusion_type', type);
    return this.http.get<any>(this.url, { params });
  }

  create(type: ExclusionType, start: string, end: string): Observable<any> {
    return this.http.post<any>(this.url, {
      exclusion_type: type,
      exclusion_start_date: start,
      exclusion_end_date: end,
    });
  }

  listNamespace(type: ExclusionType): Observable<any> {
    const params = new HttpParams().set('exclusion_type', type);
    return this.http.get<any>(this.url, { params }); // no seller id → every seller in the namespace
  }

  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.url}/${id}`);
  }
}
